/* eslint-disable no-underscore-dangle */
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Placement } from '@floating-ui/react';
import OperationContext from '../context';
import { TimelineMilestone } from '../../../../services/types/Timeline';
import { Point } from './BezierCurve';
import { customDateStr, isDraft } from '../../../../shared/misc/utils';
import MilestoneDateEditable from './MilestoneDateEditable';
import MainContext from '../../../App/MainProvider/context';

interface MilestoneInfo {
  milestone: TimelineMilestone;
  toggleMilestoneDirection: boolean;
  milestoneCalendarOpenedId: number | null;
  coords: Point;
  xMilestoneSeparation: number;
  isLast: boolean;
  calendarDirection: Placement;
  setMilestoneCalendarOpened: (milestoneId: number | null) => void;
  saveDate: (milestoneId: number, date: Date | null) => void;
}

const MilestoneInfoContainer = (props: MilestoneInfo) => {
  const {
    toggleMilestoneDirection,
    milestone,
    milestoneCalendarOpenedId: milestoneCalendarOpened,
    coords,
    isLast,
    calendarDirection,
    xMilestoneSeparation,
    setMilestoneCalendarOpened,
    saveDate,
  } = props;
  const { operation } = useContext(OperationContext);

  const { inSuperUserMode } = useContext(MainContext);
  const [editingMilestone, setEditingMilestone] = useState<boolean>(false);
  const { t } = useTranslation();
  const canEdit =
    milestone.editable && (operation.isMember || inSuperUserMode()) && !isDraft(operation);

  const compassDate = milestone.compassDate
    ? (customDateStr(milestone.compassDate) as string)
    : t('notSet');

  const startDate = milestone.startDate
    ? (customDateStr(milestone.startDate) as string)
    : t('notSet');
  const endDate = milestone.endDate ? (customDateStr(milestone.endDate) as string) : t('notSet');

  const dateNotEditable = milestone.compassDate ? compassDate : endDate;

  return (
    <div
      className={`milestone-info-container ${toggleMilestoneDirection ? 'up' : 'down'} ${
        editingMilestone && milestoneCalendarOpened === milestone.milestoneId ? 'editing' : ''
      }`}
      style={{
        left: `${coords._x - 0.5}px`,
        height: `${toggleMilestoneDirection ? 85 + coords._y : 245 - coords._y}px`,
        width: `${(isLast ? 1.5 : 2) * xMilestoneSeparation - 5}px`,
      }}
    >
      <div>
        {canEdit ? (
          <MilestoneDateEditable
            setMilestoneCalendarOpened={() => setMilestoneCalendarOpened(milestone.milestoneId)}
            isEditing={editingMilestone}
            toggleEdition={() => setEditingMilestone((prev) => !prev)}
            saveDate={saveDate}
            milestone={milestone}
            calendarDirection={calendarDirection}
            onSnake
          />
        ) : (
          <span className="date">{milestone.isMission ? startDate : dateNotEditable}</span>
        )}

        {milestone.isMission && <span className="date">{endDate}</span>}
        {milestone.color ? (
          <span style={{ color: 'red' }}>{milestone.name}</span>
        ) : (
          <span>{milestone.name}</span>
        )}
      </div>
    </div>
  );
};

export default MilestoneInfoContainer;
